import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';
import Header from './Header/Header';
import Sidebar from './Sidebar';
import Fade from '@material-ui/core/Fade';
import decorationLight from '../assets/images/decoration_light.svg';
import spinnerImg from '../assets/images/spinner.gif';

import styles from './appStyles-jss';

class Dashboard extends React.Component {
  state = {
    openGuide: false,
    appHeight: 0,
    sidebarOpen: true,
  };

  componentDidMount = () => {
    this.setState({ appHeight: window.innerHeight });
  }
  handleOpenGuide = () => {
    this.setState({ openGuide: true });
  };

  handleCloseGuide = () => {
    this.setState({ openGuide: false });
  };
  toggleDrawer = () => {
    this.setState({
      sidebarOpen: !this.state.sidebarOpen
    })
  }
  render() {
    const {
      classes,
      children,
      pageLoaded,
      mode,
      history,
      gradient,
      title,
      pageTitle
    } = this.props;
    const { appHeight, sidebarOpen } = this.state;
    return (
      <div
        style={{ minHeight: appHeight }}
        className={
          classNames(
            classes.appFrameInner,
            classes.sideNav,
            mode === 'light-mode'
          )
        }
      >
        <Helmet title={title} />
        <Fragment>
          <Header
            toggleDrawerOpen={this.toggleDrawer}
            margin={sidebarOpen}
            gradient={gradient}
            position="left-sidebar"
            mode={mode}
            title={pageTitle}
            history={history}
          />
          <Sidebar
            open={sidebarOpen}
            toggleDrawerOpen={this.toggleDrawer}
            leftSidebar
          />
          <main className={classNames(classes.content, !sidebarOpen ? classes.contentPaddingLeft : '')} id="mainContent">
            <div className={classes.bgWrap}>
              <div
                className={classNames(
                  classes.bgbar,
                  false && classes.highTop,
                  classes.solidBg,
                  classes.halfBg,
                )}
              >
                <img src={decorationLight} alt="decoration" className={classes.decorationWave} />
              </div>
            </div>
            <section className={classNames(classes.mainWrap, classes.sidebarLayout)}>
              { pageLoaded && (<img src={spinnerImg} alt="spinner" className={classes.circularProgress} />) }
              <Fade
                in={!pageLoaded}
                {...(!pageLoaded ? { timeout: 700 } : {})}
              >
                <div className={pageLoaded ? classes.hideApp : classes.appContentHeight}>
                  { children }
                </div>
              </Fade>
            </section>
          </main>
        </Fragment>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
  history: PropTypes.object,
  initialOpen: PropTypes.func,
  pageLoaded: PropTypes.bool,
  mode: PropTypes.string,
  gradient: PropTypes.bool,
  bgPosition: PropTypes.string,
  title:PropTypes.string,
  pageTitle: PropTypes.string,
};

const mapStateToProps = state => ({
  pageLoaded: false,
  mode: 'light',
  gradient: true,
  bgPosition: 'half',
  ...state,
});

const mapDispatchToProps = dispatch => ({
});

const DashboardMaped = connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);

export default (withStyles(styles)(DashboardMaped));